// /dashboard/:orgSlug/support/sent — Figma frame 23 sent (33:2884).
// Owner: screens-ops, US-133. This screen carries the privacy sentence: it says
// "we don't collect any", never "we anonymize it".
//
// `?ticket=` is optional and this route must render fine without it — direct
// arrival (bookmark, reload, shared link) with no prior submission is an
// explicit acceptance criterion, not an edge case. Same pattern as
// `routes/auth.link-sent.tsx`.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { SupportSentScreen } from "../screens/ops/SupportSentScreen";

type SupportSentSearch = { ticket?: string };

export const supportSentRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/dashboard/$orgSlug/support/sent",
  staticData: { title: "Request sent" },
  validateSearch: (search: Record<string, unknown>): SupportSentSearch => ({
    ticket: typeof search.ticket === "string" ? search.ticket : undefined,
  }),
  component: SupportSentRoute,
});

function SupportSentRoute() {
  const { orgSlug } = supportSentRoute.useParams();
  const { ticket } = supportSentRoute.useSearch();
  return (
    <SupportSentScreen orgSlug={orgSlug} ticketId={ticket ?? null} />
  );
}
